<template>

    <ul class="lista row">
        <li v-for="contenido in contenidos" :key="contenido.ContenidoDeMicrositioId" class="col-12 fuente" :class="columnasContenido(contenido.TamanoDeLaColumna)">
            {{contenido.TextoDelContenido}}
        </li>
    </ul>
</template>

<script>
export default {
    props:{
        contenidos:Array
    },
    methods: {
        columnasContenido(columnas){
                var respuesta = 'col-lg-'+columnas;
                return respuesta;

            }
    },
}
</script>

<style scoped>
.lista{
    list-style-type: disc;
}
.fuente{
    font-family: 'Myriad';
    font-size: 1.4em;
}
</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/ListaTexto.vue